var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"rounded-0 primary-background-color px-8 pb-3",attrs:{"width":_vm.width,"height":_vm.height,"min-height":_vm.minHeight,"elevation":"5"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }